import React, {useState} from 'react';
import {looper as _looper} from "helpers/timers";
import {trigger_cancel} from "services/BaseService";
import {debounce} from "lodash";

const useLooper = ({redoSearch, searchState}) => {
    const [looper] = useState(_looper)

    const startLooping = async (params = {}) => {
        await looper.loopCancel({ debug: false });
        looper.loopStart({
            ms: 5000, // 5 seconds

            loop_tick_callback: async ({ tickCount }) => {
                const { show_loading = false } = params;

                await redoSearch({
                    search_obj_for_api: {...searchState?.search_obj, ...params?.search_obj},
                    ...params,
                    show_loading: show_loading && tickCount == 0
                });
            },
        });
    };

    let restartLoop = debounce(async (params = {}) => {
        await fireCancel();

        await redoSearch({
            search_obj_for_api: {...searchState?.search_obj, ...params?.search_obj},
            ...params,
            show_loading: true
        });

        startLooping();
    }, 100);

    const fireCancel = async () => {
        if (looper) {
            await looper.loopCancel({ debug: false });
        }

        // cancel outstanding api calls
        await Promise.all([
            trigger_cancel('auctions.getOnlineAuctions'),
            trigger_cancel('auctions.getComingSoonAuctions'),
        ]);
    };


    return {looper, startLooping, restartLoop, fireCancel}
};

export default useLooper;
